const alp = {
  parameters: [
    {
      name: 'ALP-female',
      displayName: 'ALP',
      id: 'alp',
      validFrom: '2026/04/06 1:00',
      validThrough: null,
      interpretationsSupported: ['normal', 'deficiency', 'high', 'fault'],
      criteria: {
        sexe: ['female'],
        age: {
          min: 5,
          max: 110,
        },
      },
      ranges: [
        {
          color: '#6f6b72',
          description: 'ALP-female-deficiency',
          lowerLimit: 0,
          lowerLimitOperator: '>=',
          upperLimit: 35,
          upperLimitOperator: '<',
          unit: 'U/l',
          interpretation: 'deficiency',
          displayInterpretation: 'Deficiency',
          treatAs: 'normal',
          rangeInterpretation: '0 - 34',
        },
        {
          color: '#1f7359',
          description: 'ALP-female-normal',
          lowerLimit: 35,
          lowerLimitOperator: '>=',
          upperLimit: 104,
          upperLimitOperator: '<=',
          unit: 'U/l',
          interpretation: 'normal',
          displayInterpretation: 'Normal',
          rangeInterpretation: '35 - 104',
        },
        {
          color: '#f52d0a',
          description: 'ALP-female-high',
          lowerLimit: 104,
          lowerLimitOperator: '>',
          upperLimit: 600,
          upperLimitOperator: '',
          unit: 'U/l',
          interpretation: 'high',
          displayInterpretation: 'High',
          rangeInterpretation: '> 104',
        },
      ],
    },
    {
      name: 'ALP-male',
      displayName: 'ALP',
      id: 'alp',
      validFrom: '2026/04/06 1:00',
      validThrough: null,
      interpretationsSupported: ['normal', 'deficiency', 'high', 'fault'],
      criteria: {
        sexe: ['male'],
        age: {
          min: 5,
          max: 110,
        },
      },
      ranges: [
        {
          color: '#6f6b72',
          description: 'ALP-male-deficiency',
          lowerLimit: 0,
          lowerLimitOperator: '>=',
          upperLimit: 40,
          upperLimitOperator: '<',
          unit: 'U/l',
          interpretation: 'deficiency',
          displayInterpretation: 'Deficiency',
          treatAs: 'normal',
          rangeInterpretation: '0 - 39',
        },
        {
          color: '#1f7359',
          description: 'ALP-male-normal',
          lowerLimit: 40,
          lowerLimitOperator: '>=',
          upperLimit: 129,
          upperLimitOperator: '<=',
          unit: 'U/l',
          interpretation: 'normal',
          displayInterpretation: 'Normal',
          rangeInterpretation: '40 - 129',
        },
        {
          color: '#f52d0a',
          description: 'ALP-male-high',
          lowerLimit: 129,
          lowerLimitOperator: '>',
          upperLimit: 600,
          upperLimitOperator: '',
          unit: 'U/l',
          interpretation: 'high',
          displayInterpretation: 'High',
          rangeInterpretation: '> 129',
        },
      ],
    },
  ],
};

export default alp;
